import {
  createContext,
  type PropsWithChildren,
  type RefObject,
  useRef,
} from 'react';

export const FullscreenElementRefContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export function FullscreenElementRefProvider({ children }: PropsWithChildren) {
  const fullscreenRef = useRef<HTMLDivElement | null>(null);

  return (
    <FullscreenElementRefContext.Provider value={fullscreenRef}>
      {children}
    </FullscreenElementRefContext.Provider>
  );
}
